import {makeReactContext} from 'lib/makeReactContext';

export const LockedContext = makeReactContext<boolean>(() => {
  throw new Error('LockedContext not found');
}, 'LockedContext');
